/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { MSBService, PolicyService, UserService } from 'gw-capability-gateway';
import {
    GatewayBillingService,
    GatewayPaymentService,
} from 'gw-capability-gateway-billing';
import metadata from './PolicySummary.metadata.json5';
import PolicyDetailsAccordion from '../TFPAPolicyDetailsAccordion/PolicyDetailsAccordion.jsx';
import PropertyDetailsAccordion from '../TFPAPropertyDetailsAccordion/PropertyDetailsAccordion.jsx';
import ConstructionDetailsAccordion from '../TFPAConstructionDetailsAccordion/ConstructionDetailsAccordion.jsx';
import DiscountSurchargesLossAccordion from '../TFPADiscountSurchargesLossAccordion/DiscountSurchargesLossAccordion.jsx';
import CoveragesAccordion from '../TFPACoveragesAccordion/CoveragesAccordion.jsx';
import messages from './PolicySummary.messages.js'
import styles from './PolicySummary.module.scss'
import { useEffect } from 'react';

const PolicySummary = props => {
    const {
        policyDetailsData,
        policyTransactionDetails,
        producerOfServiceValue,
        producerOfRecordValue,
        policyTransactionData,
        lobData_TWIA
    } = props;

    const { authHeader } = useAuthentication();

    useEffect(() => {
        //   getPaymentSummaryByPolicyNumber()
       // getUrlAndOpen()
    }, [])

    const getPaymentSummaryByPolicyNumber = () => {
        const result = GatewayBillingService.getPaymentSummaryByPolicyNumber(policyDetailsData.policyNumber, authHeader)
    }

    const getUrlAndOpen = () => {

        const urlPromise = MSBService.getReviewMSBUrl(policyDetailsData.policyNumber, authHeader);
        return urlPromise

    };

    const yesNo = useCallback((boolVal) => {
        const result = boolVal ? 'Yes' : 'No'
        return result
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        policyDetailsSection: {
            policyDetailsData,
            policyTransactionDetails,
            producerOfServiceValue,
            producerOfRecordValue,
            policyTransactionData,
        },
        propertyDetailsSection: {
            policyDetailsData,
            getUrlAndOpen,
            yesNo
        },
        constructionDetailsSection: {
            policyDetailsData,
            yesNo
        },
        discountSurchargesLossSection: {
            policyDetailsData,
            yesNo
        },
        coveragesDetailsSection: {
            policyDetailsData,
            policyTransactionDetails,
            policyTransactionData
        }
    };



    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        },
        resolveComponentMap: {
            policyDetailsComponent: PolicyDetailsAccordion,
            propertyDetailsComponent: PropertyDetailsAccordion,
            constructionDetailsComponent: ConstructionDetailsAccordion,
            discountSurchargesLossAccordion: DiscountSurchargesLossAccordion,
            coveragesDetailsComponent: CoveragesAccordion
        }
    };




    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            //model={submissionVM}
            // onModelChange={updateWizardData}
            // onValueChange={writeValue}
            // showErrors={showErrors}
            // onValidationChange={setComponentValidation}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};

PolicySummary.propTypes = wizardProps;
PolicySummary.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};
export default withAuthenticationContext(withRouter(PolicySummary));
